import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { AuthTemplate as CroplerAuthTemplate } from '@cropler/ui-kit';

import logoUrl from '../../assets/images/logo.svg?url';
import loginImage from '../../assets/images/login.webp';
import loginImageMobile from '../../assets/images/login-mobile.webp';

import { PushNotificationTokenStatus, RefreshToken, Token } from '../../constants/keys';

export type AuthTemplateType = 'login' | 'reset' | 'signup';

interface AuthTemplateProps {
  type: AuthTemplateType;
}

const AuthTemplate = ({ type }: AuthTemplateProps) => {
  const navigate = useNavigate();
  const accessToken = localStorage.getItem(Token);
  const refreshToken = localStorage.getItem(RefreshToken);

  useEffect(() => {
    if (accessToken && refreshToken) {
      navigate('/');
      localStorage.setItem(PushNotificationTokenStatus, '');
    }
  }, [accessToken, navigate, refreshToken]);

  return (
    <>
      {(!accessToken || !refreshToken) && (
        <CroplerAuthTemplate
          image={loginImage}
          imageMobile={loginImageMobile}
          logo={{ image: logoUrl, alt: 'Cropler', width: 145, height: 40 }}
          isBodyFullScreenMobile={type === 'reset' || type === 'signup'}
        >
          <Outlet />
        </CroplerAuthTemplate>
      )}
    </>
  );
};

export default AuthTemplate;
